export default __webpack_public_path__ + "static/ikb.uebersicht-7a5640fcd2adad32ab8e1ac7de0682a9.jpg";